import React, { useEffect, useState } from 'react'
import SuccessAlert from '../../../components/Alerts/SuccessAlert';
import FailAlert from '../../../components/Alerts/FailAlert';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useMutation, useQuery } from '@apollo/client';
import { ALL_DEFINITION_PAGE, DefinitionPage, UpdateDefinitionPage } from '../../../graphql';
import { useParams } from 'react-router-dom';
import { FetchDefinitionPage } from '../../../types';
import LoadingWidget from '../../../components/LoadingWidget/LoadingWidget';
import useStore from '../../../store/useStore';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import { t } from 'i18next';

const EditDefinitionPage = () => {
  const storeData = useStore((state: any) => state.userData.store);

  const { pageId } = useParams();

  // Alerts
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  const [title, setTitle] = useState("");
  const [Description, setDescription] = useState("");

  const { data: definitionPage, loading } = useQuery<FetchDefinitionPage>(DefinitionPage, {
    variables: { definitionPageId: pageId }
  });

  useEffect(() => {
    if (definitionPage !== undefined) {
      setTitle(definitionPage.definitionPage.title)
      setDescription(definitionPage.definitionPage.description)
    }
  }, [definitionPage])

  // Update
  const [updateDefinitionPage, { error }] = useMutation(UpdateDefinitionPage);

  const submit = async (e: any) => {
    e.preventDefault()

    if (title === "") {
      setFailMsg(t('emptyTitle'));
      setFail(true);
      return
    }
    if (Description === "") {
      setFailMsg(t('emptyDescriptionAlert'));
      setFail(true);
      return
    }

    await updateDefinitionPage({
      variables: {
        updateDefinitionPageId: pageId,
        content: {
          description: Description,
          title: title,
          idStore: storeData.id
        }
      },
      refetchQueries: [{ query: ALL_DEFINITION_PAGE, variables: { idStore: storeData.id } }]
    })

    if (!error) {
      setSuccessMsg(t('pageUpdateSuccess'));
      setSuccess(true);
    }
  }

  return (
    <section className='my-4 mx-3 md:mx-7'>
      {success && <SuccessAlert success={success} setSuccess={setSuccess} successMsg={successMsg} />}

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      <div className='flex flex-col-reverse md:flex-row md:justify-between md:items-center'>
        <div>
          <h3 className='text-2xl font-semibold'>{t('editDefinitionPage')}</h3>
        </div>
        <div>
          <Breadcrumbs />
        </div>
      </div>

      <form className='relative px-5 py-2 my-2 bg-white rounded-md'>
        {loading ?
          <LoadingWidget />
          :
          <>
            <div className="mb-2">
              <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900">{t('title')}</label>
              <input type="text" id="title" value={title} onChange={(e) => setTitle(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('title')} required />
            </div>

            <div className='pt-2'>
              <label className="block mb-2 text-sm font-medium text-gray-900">{t('description')}</label>
              <CKEditor editor={ClassicEditor} data={Description} className="h-48" onChange={(event: any, editor: any) => { const data = editor.getData(); setDescription(data) }} />
            </div>

            <div className='flex justify-end my-2'>
              <div onClick={(e) => { submit(e) }} >
                <button className='inline-flex items-center justify-center px-4 py-2 my-2 overflow-hidden text-sm text-white transition-colors duration-300 rounded-lg shadow bg-primary hover:bg-primaryHover'>
                  <span className="mx-2">
                    {t('save')}
                  </span>
                </button>
              </div>
            </div>
          </>
        }
      </form>
    </section>
  )
}

export default EditDefinitionPage